import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import AutocompleteField from '#client/components/AutocompleteField';

import useStateField from './useStateField';

function StateField({ defaultValue, helperText, namePrefix, validation, ...delegated }) {
  const { formatMessage } = useIntl();

  return (
    <AutocompleteField
      defaultValue={defaultValue}
      helperText={helperText}
      label={formatMessage({
        id: 'shopping.component.addressFieldset.stateField.label'
      })}
      namePrefix={namePrefix}
      {...delegated}
      handleField={useStateField}
      validation={validation}
    />
  );
}

StateField.propTypes = {
  defaultValue: PropTypes.string,
  helperText: PropTypes.string,
  namePrefix: PropTypes.string,
  validation: PropTypes.object
};

export default StateField;
